module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/images/icon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"f26b5f9d729e86d6bdf2d1864e7f191b"},
    },{
      plugin: require('../node_modules/@seeka-labs/gatsby-plugin-seeka/gatsby-browser.js'),
      options: {"plugins":[],"publicKey":"sdkr_Q2ZESjhLd1FDb2dDUkZCR2pBeWFOOUUxNVhRTHpUcnNCNVVlWWNyYVF2RVVTWlNGQ3JUdlprU2E0aGpwZC1qN1pUeGktLWI5TFcxU0tvUVdUMG12M1dLcUJiMk44SlV2Y29Kc1dmQUJDd3NnNkdyTDZZZXppLWp2ZWIwUVhBZWUxa0s4bDQzZ28xLXdfRGllSkJnN3JCaTFSOGtzZFFjeUhRWTdNX0RIZHJrYmlPUDA","org":"83fa3bcd95637d81a2463a07b98446f8","id":"eda7ec1f8e9e95bc99573a07b9846364","waitForInteraction":true},
    },{
      plugin: require('../gatsby-browser.tsx'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
